export default __webpack_public_path__ + "static/media/2150.517d3847.png";